import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CareTeamService } from 'src/app/services/careTeam.service';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-care-team-section',
  templateUrl: './care-team-section.component.html',
  styleUrls: ['./care-team-section.component.css'],
  standalone: false,
})
export class CareTeamSectionComponent {
  constructor(
    private readonly careTeamService: CareTeamService,
    private readonly eocService: EpisodeOfCareService,
    private readonly router: Router,
    private readonly permissionService: PermissionService
  ) {}

  handleButton() {
    this.careTeamService.careTeamEditSub.next(undefined);
    this.careTeamService.careTeamModalSub.next(true);
  }

  isEOC() {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('episodeOfCare')
    );
  }

  isInpatientView() {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('inPatientView')
    );
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }
}
